import { message } from "antd";
import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getDistributorsList(params?: any) {
  let res = {
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  };
  if(params) {
    params = removeEmpty(params)
  }
  await Api.get(endpoints.getDistributorsList, {params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError(`Could not get distributors list`)
  })

  return res
}

export async function changeDistributorStatus(params: any) {

  await Api.get(endpoints.changeDistributorStatus, {params}).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Status updated successfully')
      }
    } else {
      notificationError(`Could not change distributor status`)
    }
  }).catch((err: string) => {
    notificationError(`Could not change distributor status`)
  })

}

export async function getDistributorServers(params: any) {
  let res = {
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  };
  await Api.get(endpoints.getDistributorServers, {params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError(`Could not get distributors list`)
  })

  return res

}

export async function changeServerStatus(params: any) {
  await Api.get(endpoints.changeServerStatus, {params}).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Status updated successfully')
      }
    }
  }).catch((err: string) => {
    notificationError(`Could not change distributor status`)
  })

}

export async function deleteServerById(params: any) {
  await Api.get(endpoints.deleteServerById, {params}).then((response) => {
    
    if(response.data && response.data.return) {
      notificationSucces('Status updated successfully')
    }
  }).catch((err: string) => {
    notificationError(`Could not change distributor status`)
  })

}

export async function changeDefaultServerById(params: any) {
  await Api.get(endpoints.changeDefaultServerById, {params}).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Default server updated successfully')
      }
    } else {
      notificationError(`Could not change default server`)
    }
  }).catch((err: string) => {
    notificationError(`Could not change default server`)
  })

}

export async function createOrUpdateServer (payload: any) {

  await Api.post(endpoints.createOrUpdateServer, payload).then((response) => {
    if(response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Request sent successfully')
      }
    } else {
      notificationError('Could not send request to the server')
    }
  }).catch((err: string) => {
    notificationError('Could not send request to the server')
  })

}

export async function getServerById (params: any) {
  let res = {
    activeLocations: '',
    defaultServer: "false",
    distributorId: '',
    externalId: "",
    externalPortOverride: "",
    id: '',
    internalPortOverride: "0",
    serverAddress: "",
    serverAddressPrivate: "",
    serverAlias: "",
    status: "",
  };

  await Api.get(endpoints.getServerById, {params}).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.error}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Unable to get server information')
  })

  return res
}

export async function createOrUpdateDistributor (payload: any) {

  await Api.post(endpoints.createOrUpdateDistributor, payload).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        if (response.data.return===true) {
          notificationSucces('Distributor was successfully updated')
        } else {
          notificationError('Could not save distributor')
        }
      }
    } else {
      notificationError('Could not save distributor')
    }
  }).catch((err: string) => {
    notificationError('Could not save distributor')
  })

}

export async function getDistributorImage(params: any) {
  let res: string = ''
  await Api.get('/distributors/showimage', {params, responseType: 'blob'}).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        if(response.data && response.data.size) {
          const objectUrl = URL.createObjectURL(response.data)
          res = objectUrl
        }
      }
    } else {
      notificationError('Could not get image')
    }
  }).catch((err: string) => {
    notificationError('Could not get image')
  })

  return res
}

export async function uploadDistributorImage(params: any) {

  await Api.post('/distributors/upload', {...params}, {
    headers: {
      'content-type': 'multipart/form-data',
    }
  }).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      }
    } else {
      notificationError('Could not upload image')
    }
  }).catch((err: string) => {
    notificationError('Could not upload image')
  })

}

export async function getDistributorById (params: any) {
  
  let res = {
    name: "",
    address: "",
    zipcode: "",
    city: "",
    state: "",
    phone: "",
    email: "",
    status: "Active",
    disableDeckManagement: false,
    pinCode: "",
    mdorBusinessName: "",
    mdorEtin: "",
    mdorFein: "",
    mdorLicenseNumber: "",
    mdorPermitId: "",
    mdorContactFirstname: "",
    mdorContactLastname: "",
    mdorContactTitle: "",
    mdorContactPhone: "",
    mdorContactFax: "",
    mdorAddressLine1: "",
    mdorAddressLine2: "",
    mdorCity: "",
    mdorState: "",
    mdorZipcode: "",
    mdorEmail: "",
    image: "",
  };

  await Api.get(endpoints.getDistributorById, {params}).then((response) => {
    res = response.data
    if(!res || res.name === '') {
      notificationError('Unable to get distributor information')
    }
  }).catch((err: string) => {
    notificationError('Unable to get distributor information')
  })

  return res
}
